'use strict';

var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');
var Page = require('pages/Page/Page.js');

require('./Index.less');

var IndexExperiences = require('components/IndexExperiences/IndexExperiences.js');
var IndexFreedom = require('components/IndexFreedom/IndexFreedom.js');
var IndexPower = require('components/IndexPower/IndexPower.js');
var IndexMoments = require('components/IndexMoments/IndexMoments.js');
var IndexContact = require('components/IndexContact/IndexContact.js');
var IndexFrame = require('components/IndexFrame/IndexFrame.js');

module.exports = Page.extend({

    events: {
        'keydown': 'onKeyDown',
    },

    initialize: function (options) {

        _.bindAll(this, 'gotoFirstSection', 'gotoSection', 'gotoPrevSection', 'gotoNextSection');

        //store current mouse position for Globe section
        app.globoPos = {x: 0, y: 0};
        app.mouse = {x: 0, y: 0};

        if (app.settings.isDesktop) {
            app.els.$window.on('mousemove', function (event) {
                var mouse = {x: 0, y: 0};
                var PI_HALF = Math.PI / 2;

                app.mouse.x = event.pageX;
                app.mouse.y = event.pageY;

                mouse.x = -event.clientX;
                mouse.y = event.clientY - window.innerHeight / 2;

                app.globoPos.x = mouse.x * 0.003;
                app.globoPos.y = mouse.y * 0.003;

                app.globoPos.y = app.globoPos.y > PI_HALF ? PI_HALF : app.globoPos.y;
                app.globoPos.y = app.globoPos.y < -PI_HALF ? -PI_HALF : app.globoPos.y;
            });
        } else {
            window.addEventListener('deviceorientation', function(e) {
                var PI_HALF = Math.PI / 2;
                var x, y;

                switch (window.orientation) {
                    case 0:
                        y = -(.02 * e.beta - .25 * Math.PI);
                        x = .03 * -e.gamma;
                        break;
                    case 90:
                        y = -(.02 * -e.gamma - .25 * Math.PI);
                        x = .04 * -e.beta;
                        break;
                    case -90:
                        y = -(.02 * e.gamma - .25 * Math.PI);
                        x = .04 * e.beta;
                }

                y > .5 ? y = .5 : y < -.5 && (y = -.5);
                x > .5 ? x = .5 : x < -.5 && (x = -.5);

                app.globoPos.x = x * -3 - 1.5;
                app.globoPos.y = y * 2;

                app.globoPos.y = app.globoPos.y > PI_HALF ? PI_HALF : app.globoPos.y;
                app.globoPos.y = app.globoPos.y < -PI_HALF ? -PI_HALF : app.globoPos.y;
            }, false);
        }

        this.sections = [
            new IndexExperiences({page: this}),
            new IndexFreedom({page: this}),
            new IndexPower({page: this}),
            new IndexMoments({page: this}),
            new IndexContact({page: this})
        ];

        this.initLoader();
    },


    onResourcesReady: function() {
        this.frame = new IndexFrame({page: this});
        this.frame.on('go-to-first', this.gotoFirstSection);
        this.frame.on('go-to-section', this.gotoSection);
        this.frame.on('policy-shown', function() {
            this.slideScrollController.pauseListen('policy');
        }.bind(this));
        this.frame.on('policy-hidden', function() {
            this.slideScrollController.resumeListen('policy');
        }.bind(this));

        this.slideScrollController = new SlideScrollController({$el: this.$el, page: this});
        this.slideScrollController.on('slide-up', this.gotoPrevSection);
        this.slideScrollController.on('slide-down', this.gotoNextSection);

        this.gotoFirstSection();
    },


    initLoader: function() {

        var resources = [];
        var self = this;

        //get list of all resources
        _.each(this.sections, function(section) {
            var sectionResources = section.getResources();

            _.each(sectionResources, function(value, key) {
                var resource = {
                    section: section,
                    id: key,
                    resource: value,
                    size: undefined,
                    loaded: 0
                }

                resources.push(resource);
            });
        });

        var onGetSize = _.after(resources.length, onAllSizesKnown);
        var totalSize = 0;
        var totalLoadedCount = 0;

        //get all resources sizes
        _.each(resources, function(item) {
            var xhr = new XMLHttpRequest();
            var src = item.resource;

            xhr.open("HEAD", src, true); // Notice "HEAD" instead of "GET",

            //  to get only the header
            xhr.onreadystatechange = function() {
                if (this.readyState == this.DONE) {
                    item.size = parseInt(xhr.getResponseHeader("Content-Length"));
                    totalSize += item.size;
                    onGetSize();
                }
            };

            xhr.send();
        });


        //when all sizes have become known
        function onAllSizesKnown() {
            //alert(resources.length + ' ' + totalSize);

            _.each(resources, function(item) {
                var xhr = new XMLHttpRequest(),
                    src = item.resource;

                xhr.addEventListener('progress', function(e) {
                    if (e.lengthComputable) {
                        item.loaded = e.loaded;
                        updateProgress();
                    }
                });

                xhr.addEventListener('load', function(blob) {
                    if (xhr.status == 200) {
                        totalLoadedCount++;

                        //for cases when some traffic packers used (Opera Turbo for example), actual downloaded size is lower than expected
                        item.loaded = item.size;
                        updateProgress();

                        item.blob = window.URL.createObjectURL(xhr.response);
                    }
                });

                xhr.open('GET', src);
                xhr.responseType = 'blob';
                xhr.send(null);
            });
        }

        function updateProgress() {
            var totalLoaded = _.reduce(resources, function(res, item) {return res + item.loaded}, 0);
            var percentage = totalLoaded == totalSize ? 1 : totalLoaded / totalSize;

            self.$('.PageIndex-loader-percentage').text(Math.round(percentage * 100));

            if (totalLoadedCount == resources.length) {

                setTimeout(function() {

                    _.each(self.sections, function(section) {
                        var sectionResources = {};

                        _.each(resources, function(item) {
                            if (item.section == section) {
                                sectionResources[item.id] = item.blob;
                            }
                        });

                        section.setResources(sectionResources);

                        section.trigger('resources-ready');
                    });

                    self.onResourcesReady();

                    setTimeout(function() {
                        self.$('.PageIndex-loader').addClass('PageIndex-loader--hidden');
                    }, 200);
                }, 17);
            }
        }
    },


    onKeyDown: function(e) {
        if (e.keyCode == 33 || e.keyCode == 38) this.gotoPrevSection();//pgUp, up
        if (e.keyCode == 34 || e.keyCode == 40 || e.keyCode == 32) this.gotoNextSection();//pgDn, down, space
    },


    gotoFirstSection: function () {
        this.showSection({index: 0});
    },


    gotoSection: function(index) {
        this.showSection({index: index});
    },


    gotoPrevSection: function () {
        this.showSection({index: this.currentVisibleSectionIndex - 1});
    },


    gotoNextSection: function () {
        this.showSection({index: this.currentVisibleSectionIndex + 1});
    },


    showSection: function (params) {
        params = params || {};

        params.index -= 0; //convert to integer;

        if (this.sectionChangeInProgress) return;
        if (params.index < 0) return;
        if (params.index > this.sections.length - 1) return;
        if (params.index == this.currentVisibleSectionIndex) return;

        var prevVisibleSectionIndex = this.currentVisibleSectionIndex;

        this.sectionChangeInProgress = true;
        this.trigger('section-change-start', params.index);

        if (prevVisibleSectionIndex !== undefined) {
            this.sections[prevVisibleSectionIndex].hide({
                direction: params.index > prevVisibleSectionIndex ? 'forward' : 'backward',
                isMoving: this.sections[prevVisibleSectionIndex].NEXT_SECTION_MOVE,
            });
        }

        this.sections[params.index].show({
            noAnimation: prevVisibleSectionIndex == undefined,
            direction: params.index > prevVisibleSectionIndex ? 'forward' : 'backward',
            isMoving: prevVisibleSectionIndex == undefined ? false : this.sections[prevVisibleSectionIndex].NEXT_SECTION_MOVE,
            animationEndCallback: function () {
                this.sectionChangeInProgress = false;
                this.trigger('section-change-end', params.index);
            }.bind(this)
        });

        this.currentVisibleSectionIndex = params.index;
    }
});


var SlideScrollController = Backbone.View.extend({

    initialize: function (params) {
        _.bindAll(this, 'mouseWheelHandler');

        this.page = params.page;

        this.page.on('section-change-start', function () {
            this.pauseListen('section-switch');
        }.bind(this));

        this.page.on('section-change-end', function () {
            this.resumeListen('section-switch');
        }.bind(this));

        this.pauseStates = {};

        this.scrollings = [];
        this.prevTime = new Date().getTime();

        if (app.settings.isDesktop) {
            this.addMouseWheelHandler();
        } else {

            // $(window).on('mousemove', function(e) {
            //     e.preventDefault();
            // });

            params.$el.swipe({
                allowPageScroll: 'vertical',
                threshold: 50,
                excludedElements: "button, input, select, textarea, .noSwipe",
                swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
                    if (!this.isPaused()) {
                        if (direction == 'up') {
                            this.trigger('slide-down');
                        }
                        if (direction == 'down') {
                            this.trigger('slide-up');
                        }
                    }
                }.bind(this)
            });
        }
    },


    isPaused: function() {
        return this.pauseStates['section-switch'] || this.pauseStates['policy'];
    },


    pauseListen: function(tp) {
        this.pauseStates[tp] = true;
    },


    resumeListen: function(tp) {
        this.pauseStates[tp] = false;
    },


    addMouseWheelHandler: function () {
        var prefix = '';
        var _addEventListener;

        if (window.addEventListener) {
            _addEventListener = "addEventListener";
        } else {
            _addEventListener = "attachEvent";
            prefix = 'on';
        }

        // detect available wheel event
        var support = 'onwheel' in document.createElement('div') ? 'wheel' : // Modern browsers support "wheel"
            document.onmousewheel !== undefined ? 'mousewheel' : // Webkit and IE support at least "mousewheel"
                'DOMMouseScroll'; // let's assume that remaining browsers are older Firefox

        if (support == 'DOMMouseScroll') {
            document[_addEventListener](prefix + 'MozMousePixelScroll', this.mouseWheelHandler, false);
        }

        //handle MozMousePixelScroll in older Firefox
        else {
            document[_addEventListener](prefix + support, this.mouseWheelHandler, false);
        }
    },


    mouseWheelHandler: function (e) {
        var curTime = new Date().getTime();

        // cross-browser wheel delta
        e = e || window.event;
        var value = e.wheelDelta || -e.deltaY || -e.detail;
        var delta = Math.max(-1, Math.min(1, value));

        var horizontalDetection = typeof e.wheelDeltaX !== 'undefined' || typeof e.deltaX !== 'undefined';
        var isScrollingVertically = (Math.abs(e.wheelDeltaX) < Math.abs(e.wheelDelta)) || (Math.abs(e.deltaX) < Math.abs(e.deltaY) || !horizontalDetection);

        //Limiting the array to 150 (lets not waste memory!)
        if (this.scrollings.length > 149) {
            this.scrollings.shift();
        }

        //keeping record of the previous scrollings
        this.scrollings.push(Math.abs(value));

        //time difference between the last scroll and the current one
        var timeDiff = curTime - this.prevTime;
        this.prevTime = curTime;

        //haven't they scrolled in a while?
        //(enough to be consider a different scrolling action to scroll another section)
        if (timeDiff > 200) {
            //emptying the array, we dont care about old scrollings for our averages
            this.scrollings = [];
        }

        if (!this.isPaused()) {
            var averageEnd = getAverage(this.scrollings, 10);
            var averageMiddle = getAverage(this.scrollings, 20);
            var isAccelerating = averageEnd >= averageMiddle;

            //to avoid double swipes...
            if (isAccelerating && isScrollingVertically) {
                if (delta < 0) {
                    this.trigger('slide-down');
                } else {
                    this.trigger('slide-up');
                }
            }
        }

        /**
         * Gets the average of the last `number` elements of the given array.
         */
        function getAverage(elements, number) {
            var sum = 0;

            //taking `number` elements from the end to make the average, if there are not enought, 1
            var lastElements = elements.slice(Math.max(elements.length - number, 1));

            for (var i = 0; i < lastElements.length; i++) {
                sum = sum + lastElements[i];
            }

            return Math.ceil(sum / number);
        }
    },

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/pages/Index/Index.js
 ** module id = 6
 ** module chunks = 0
 **/